import { render, staticRenderFns } from "./Control.vue?vue&type=template&id=4e6a7a52"
import script from "./Control.vue?vue&type=script&lang=ts"
export * from "./Control.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports